import React, { useContext, useRef } from "react";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";
import { Measurement } from "../classes/measurements/measurement";
import { GoalMeasurementIdPropsShape } from "../interfaces/componentTypes";

export const GoalMeasurementId: React.FunctionComponent<GoalMeasurementIdPropsShape> = ({
  DBObject,
  handleSelect,
  goalState,
}) => {
  const { t, uuid } = useContext(TMDataContext);
  var titleRef = useRef();
  var measurements = DBObject["Measurement"];

  const handleClick = (option) => {
    var selection = measurements.find(
      (selection) => selection.label == option.currentTarget.value
    );
    handleSelect(selection.id);
  };

  const measurementDropdown = () => {
    var dropdownList = measurements.map((element) => {
    if (element.label == "Weight" || element.label == "Daily Distance" || element.label == "Daily Steps" || element.label == "Weight/poids") { 
      return (
        <option key={uuid()} id={element.id} value={element.label}>
          {element.labelWithUnits()}
        </option>
      );
    }});

    return (
      <>
        <div
          className="btn-group"
          role="group"
          style={{ display: "flex", flexDirection: "column" }}
          aria-label="Basic Example"
        >
          <select
            id="goal-measurement-selector"
            ref={titleRef}
            value={
              goalState.measurementId
                ? Measurement.findById(goalState.measurementId).label
                : ""
            }
            title="goal-measurement"
            className="goal-minimal-dropdown"
            style={{ marginLeft: "0px" }}
            onChange={(e) => {
              handleClick(e);
            }}
          >
            <option disabled value="">
              {t("views.goals.headings.select")}
            </option>
            {dropdownList}
          </select>
        </div>
        <div
          id="goal-measurement-selected"
          className="goal-minimal-dropdown-static"
          style={{ display: "none" }}
        ></div>
      </>
    );
  };

  return (
    <div className="goal-boxed-input-area">
      <div className="goal-form-input-row align-middle">
        <label
          className="goal-input-area-title"
          htmlFor="goal-measurement-type-dropdown"
        >
          {t("views.goals.headings.measurement_type")}
        </label>

        {measurementDropdown()}
      </div>
    </div>
  );
};
